import React from "react";
import styled from "styled-components";

import PageWrapper from "../components/PageWrapper";
import About from "../sections/others/About";
import CTA from "../sections/landing4/CTA";
import Seo from "../components/Seo";
import { personJsonLd } from "../data/jsonld";

const Wrap = styled.div`
  background: var(--nd-black);
  color: var(--nd-text-primary);
  padding-top: 112px;
  min-height: 80vh;
`;

const AboutPage = () => {
  return (
    <>
      <Seo
        title="About Dioscuro"
        description="Founded by Fabio Palumbo, 15+ years in cloud infrastructure across Endava, PwC, Consensys Infura, BlockFi. Small senior team — Buenos Aires + remote."
        pathname="/about"
        jsonLd={personJsonLd}
      />
      <PageWrapper darkTheme>
        <Wrap>
          <About />
        </Wrap>
        <CTA />
      </PageWrapper>
    </>
  );
};

export default AboutPage;
